import { defineComponent as _defineComponent } from 'vue'
import LoadingAnimationSmall from '@/modules/shared/components/loading-animation/LoadingAnimationSmall.vue';

export default /*#__PURE__*/_defineComponent({
  __name: 'DashboardWidgetStreaming',
  setup(__props) {


return { __sfc: true,LoadingAnimationSmall }
}

})